import React, { useEffect, useState } from 'react';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Form, Select, Space, DatePicker, Table, Row, Col, message, Popover, Radio } from 'antd';
import { useHistory, useParams } from 'react-router-dom';
import { getAddressList } from '../apis/address';
import moment from 'moment';
import { orderDomesticInfo, orderDomesticSave, orderDomesticCompanyLists } from './api';

const { Option } = Select;
const baseNumber = [0.5, ...(Array.from({ length: 99 }).map((item, index) => index + 1))];
const dateFormat = 'YYYY-MM-DD';
const QuotationEdit = () => {
  const [form] = Form.useForm();
  const history = useHistory();
  const params = useParams();
  const { reportType, transportation_id, quotation_no } = params;
  const [addressList, setAddressList] = useState([]);
  const [quotationInfo, setQuotationInfo] = useState({});
  const [companyList, setCompanyList] = useState([]);
  const [list, setList] = useState([]);
  // const [currentIndex, setCurrentIndex] = useState();
  // const [currentValue, setCurrentValue] = useState();


  useEffect(() => {
    requestAddressList();
    const requestOrderDomesticInfo = async () => {
      const { data: { data: quotationInfo = {} } } = await orderDomesticInfo({ quotation_no, transportation_id });
      const { submit = [], product_info } = quotationInfo;
      const list = submit.map(item => {
        const { address, address_id, expecteds } = item;
        return expecteds.map(subItem => ({ ...subItem, address, address_id, product_info, baseAddress: address }));
      }).flat().map((item, index) => ({ ...item, index }));
      setQuotationInfo(quotationInfo);
      setList(list);
    };
    const orderDomesticCompanyList = async () => {
      const { data: { data: { list = [] } } } = await orderDomesticCompanyLists({ quotation_no, transportation_id });
      setCompanyList(list.map(item => ({ ...item, expected_id: item.id })));
    };
    orderDomesticCompanyList();
    requestOrderDomesticInfo();
    // if (reportType === '1') {
    form.setFieldsValue({
      // sights: [{ date: '', submit_number: '' }],
      sights: [{ date: '', submit_number: '', submit_type: '', expected_id: '' }],
    });
    // }
  }, [transportation_id, reportType, quotation_no, form]);


  const onFinish = (values) => {
    const { product_info = [], city_id } = quotationInfo;
    const { address_id, sights = [] } = values;
    const address = addressList.find(subItem => String(subItem.id) === String(address_id));
    if (!sights.length) {
      message.error('请添加期望到港日期后重试');
    } else if (String(city_id) !== String(address?.city_id)) {
      message.error('该报价单无当前地址！');
    } else {
      const addList = sights.map(item => {
        const { date, submit_type = 0, expected_id = 0 } = item;
        const expected_date = moment(date).format(dateFormat);
        return { address_id, ...item, expected_date, address, product_info, status: 1, add: true, submit_type, expected_id, currentItemKey: `${address_id}-${expected_date}` };
      }).reverse();
      const addListKeys = addList.map(item => item.currentItemKey);
      const formatList = list.map(item => addListKeys.includes(`${item.address_id}-${item.expected_date}`) ? { ...item, status: 0 } : item);
      const newList = [...addList, ...formatList].map((item, index) => ({ ...item, index }));
      const condition = newList.filter(item => +item.status === 1 && +item.submit_number === 0.5);

      if (condition.length > 1) {
        message.info(`您已进行拼单！`);
      }
      if (condition.length < 2) {
        setList(newList);
        form.setFieldsValue({
          address_id: '',
          sights: [{ date: '', submit_number: '', submit_type: '', expected_id: '' }],
        });
      }
    }
  };

  const handleChange = () => {
    form.setFieldsValue({
      sights: [{ date: '', submit_number: '', submit_type: '', expected_id: '' }],
    });
  };

  const requestAddressList = async () => {
    let { data: { data: { list = [] } } } = await getAddressList();
    list.sort((a, b) => b.is_default - a.is_default);
    setAddressList(list);
    // setCurrentAddress(list[0]);
  };
  const deleteItem = (info) => {
    const { address_id, expected_date, submit_number } = info;
    const uniqueKey = address_id + '-' + expected_date + '-' + submit_number;
    // const newList = list.filter(item => {
    //   const { address_id, expected_date } = item;
    //   const uniqueItemKey = address_id + '-' + expected_date;
    //   return uniqueKey !== uniqueItemKey;
    // }).map((item, index) => ({ ...item, index }));
    const newList = list.map(item => {
      const { address_id, expected_date, submit_number } = item;
      const uniqueItemKey = address_id + '-' + expected_date + '-' + submit_number;
      return uniqueKey !== uniqueItemKey ? item : { ...item, status: 0 };
    }).map((item, index) => ({ ...item, index }));
    setList(newList);
  };

  // const onDatePickerChange = (info, e) => {
  //   const expectedDate = moment(e).format(dateFormat);
  //   const { address_id, expected_date, index } = info;
  //   const currentItemKey = address_id + '-' + expected_date + '-' + index;
  //   const newList = list.map(item => {
  //     return (currentItemKey === item.address_id + '-' + item.expected_date + '-' + item.index) ? { ...item, expected_date: expectedDate } : item;
  //   }).map((item, index) => ({ ...item, index }));
  //   setList(newList);
  // };

  // const handleItemChange = (info, e) => {
  //   const { address_id, expected_date, index } = info;
  //   const currentItemKey = address_id + '-' + expected_date + '-' + index;
  //   const newList = list.map(item => {
  //     return (currentItemKey === item.address_id + '-' + item.expected_date + '-' + item.index) ? { ...item, address_id: e } : item;
  //   }).map((item, index) => ({ ...item, index }));
  //   setList(newList);
  // };

  // const onNumberChange = (info, e) => {
  //   const value = (parseFloat(e)) || 0;
  //   setCurrentValue(value);
  // };
  // const onNumberFocus = (record, index) => {
  //   const { submit_number = 0 } = record;
  //   setCurrentIndex(index);
  //   setCurrentValue(submit_number);
  // };
  // const onNumberBlur = (info) => {
  //   const { address_id, expected_date, index } = info;
  //   const currentItemKey = address_id + '-' + expected_date + '-' + index;
  //   const newList = list.map(item => {
  //     return (currentItemKey === item.address_id + '-' + item.expected_date + '-' + item.index) ? { ...item, submit_number: currentValue || 0 } : item;
  //   }).map((item, index) => ({ ...item, index }));
  //   setList(newList);
  //   setCurrentIndex();
  //   setCurrentValue();
  // };

  const columns = [
    {
      title: "期望到港日期",
      dataIndex: "expected_date",
      align: "center",
      key: 'index',
      render: (text, record) => {
        const { expected_date } = record;
        return `${expected_date}`;
        // return reportType === '1' ? `${expected_date}` : <DatePicker
        //   value={expected_date ? moment(expected_date, dateFormat) : undefined}
        //   onChange={(e) => onDatePickerChange(record, e)}
        //   allowClear={false}
        // />;
      }
    },
    {
      title: "填报数量",
      dataIndex: "submit_number",
      align: "center",
      key: 'index',
      render: (text, record, index) => {
        return <>
          {
            `${text}`
            // reportType === '1' ? `${text}` : <InputNumber
            //   min={0}
            //   defaultValue={text}
            //   autoFocus={index === currentIndex}
            //   onFocus={() => onNumberFocus(record, index)}
            //   onBlur={() => onNumberBlur(record)}
            //   onChange={(e) => onNumberChange(record, e)}
            //   style={{ width: '90%' }}
            // />
          } 柜
        </>;
      }
    },
    {
      title: "拼柜方",
      dataIndex: "expected_id",
      align: "center",
      key: 'index',
      render: (text, record, index) => {
        const { company_name = '' } = companyList.find(item => item.expected_id === text) || { company_name: '' };
        return company_name;
      }
    },
    {
      title: "收货地址",
      dataIndex: "address_id",
      align: "center",
      key: 'index',
      width: 300,
      render: (text, record) => {
        // const { address: addressInfo, address_id, baseAddress = {} } = record;
        const { address: addressInfo } = record;
        const { province_name, city_name, district_name, address, area_name } = addressInfo;
        // const newAddressList = addressList.find(item => String(item.id) === String(baseAddress?.id)) ? addressList : [...addressList, baseAddress];
        const addressDetail = province_name + city_name + (district_name || area_name) + address;
        return `${addressDetail}`;
        // return reportType === '1' ? `${addressDetail}` : <Select className='quotation-edit-container-item-select' value={address_id} onChange={(e) => handleItemChange(record, e)}>
        //   {newAddressList.map((item, index) => <Option key={index} value={item?.id}>{`${item?.province_name}${item?.city_name}${item?.area_name}${item?.address}`}</Option>)}
        // </Select>;
      }
    },
    {
      title: "操作",
      dataIndex: "",
      align: "center",
      key: 'index',
      render: (text, record) => {
        const { product_info = [], submit_number } = record;
        const content = product_info.map(item => `<tr key={item.id}>
          <td style='padding:10px;border: 1px solid #e9e9e9;'>${item.sku_name}</td>
          <td style='padding:10px;border: 1px solid #e9e9e9;'>${item.number_of_boxes * submit_number}${item.sale_unit}</td>
        </tr>`).join('');
        return <>
          <Button type='link' onClick={() => deleteItem(record)}>删除</Button>
          <Popover content={<pre><div dangerouslySetInnerHTML={{ __html: `<table style=' border: 1px solid #e9e9e9;'><tbody>${content}</tbody></table>` }} ></div></pre>}>
            <Button type='link'>查看明细</Button>
          </Popover>
        </>;
      }
    }
  ];

  const cancelEdit = () => {
    history.goBack();
  };

  const save = async () => {
    const baseSubmits = list.map(item => {
      const { address_id, expected_date, submit_number, status, add, expected_id = 0, submit_type = 0 } = item;
      return { address_id, expected_date, submit_number, status, add, expected_id, submit_type };
    });
    // const submits = reportType === '1' ? (baseSubmits.filter(item => item.status)) : baseSubmits;
    const submits = baseSubmits;
    const { data: { code, msg } } = await orderDomesticSave({ transportation_id, quotation_no, submits });
    if (+code === 0) {
      message.success(msg, .5, history.goBack());
    } else {
      message.error(msg);
    }
  };

  const datePickerChange = (fields = {}, key, cIndex, e) => {
    const { sights = [] } = form.getFieldsValue();
    const dates = sights.map(item => item?.date ? moment(item?.date).format(dateFormat) : '');
    const currentDate = e ? moment(e).format(dateFormat) : '';
    const list = dates.filter(item => item === currentDate);
    let newSights = sights;
    if (list.length > 1) {
      message.error(`当前${currentDate}到港日期已经添加`);
      newSights = sights.map((item, index) => index === cIndex ? { ...item, date: '' } : item);
      form.setFieldsValue({ sights: newSights });
    } else {

      const list = companyList.filter(item => item.expected_date === currentDate);
      const { submit_number } = sights[cIndex];
      const { id = '' } = list[0] || {};
      if (+submit_number === 0.5) {
        newSights = sights.map((item, index) => index === cIndex ? { ...item, expected_id: id, submit_type: list.length ? 2 : 1 } : item);
      } else {
        newSights = newSights.map((item, index) => index === cIndex ? { ...item, expected_id: '', submit_type: 1 } : item);
      }
      form.setFieldsValue({ sights: newSights });
    }
  };
  const submitNumberChange = (fields = {}, key, cIndex, e) => {
    const { sights = [] } = form.getFieldsValue();
    let newSights = sights.map((item, index) => index === cIndex ? { ...item, submit_number: e } : item);
    if (+e === 0.5) {
      const { date } = newSights[cIndex];
      const current_date = date ? moment(date).format(dateFormat) : '';
      const list = companyList.filter(item => item.expected_date === current_date);
      const { id = '' } = list[0] || {};
      newSights = newSights.map((item, index) => index === cIndex ? { ...item, expected_id: id, submit_type: list.length ? 2 : 1 } : item);
    } else {
      newSights = newSights.map((item, index) => index === cIndex ? { ...item, expected_id: '', submit_type: '' } : item);
    }
    form.setFieldsValue({
      sights: newSights,
    });
  };
  const radioChange = (fields = {}, key, cIndex, e) => {
    const { sights = [] } = form.getFieldsValue();
    const newSights = sights.map((item, index) => index === cIndex ? { ...item, submit_type: e.target.value, expected_id: +e.target.value === 1 ? '' : item.expected_id } : item);
    form.setFieldsValue({
      sights: newSights,
    });
  };
  const disabledDate = (current) => {
    return current && (current < moment(quotationInfo.estimated_arrival_data_start) || current > moment(quotationInfo.estimated_arrival_data_end).add(1, 'day'));
  };
  return (
    <div className='quotation-edit-container'>
      {/* <div className='quotation-edit-title'>
        <Row>
          <Col span={8}>预计离港周期(ETD):{`${quotationInfo?.estimated_departure_date_start}~${quotationInfo?.estimated_departure_date_end}`}</Col>
          <Col span={8}>计划收集周期:{`${quotationInfo?.plan_collect_start}~${quotationInfo?.plan_collect_end}`}</Col>
        </Row>
      </div> */}
      <Form form={form} name="dynamic_form_nest_item" onFinish={onFinish} autoComplete="off">
        <Form.Item
          label="预计到港周期(ETA)"
        >
          {`${quotationInfo.estimated_arrival_data_start}~${quotationInfo.estimated_arrival_data_end}`}
        </Form.Item>
        <Form.Item
          name="address_id"
          label="选择收货地址"
          rules={[
            {
              required: true,
              message: '请选择收货地址',
            },
          ]}
        >
          <Select onChange={handleChange}>{addressList.map(item => <Option key={item?.id} value={item?.id}>{`${item?.province_name}${item?.city_name}${item?.area_name}${item?.address}`}</Option>)}</Select>
        </Form.Item>
        <Form.List name="sights">
          {(fields, { add, remove }) => (
            <>
              {fields.map((field, index) => {
                const current_form_value = form?.getFieldsValue()?.sights?.[index] || {};
                const submit_number = current_form_value?.submit_number;
                const date = current_form_value?.date ? moment(current_form_value?.date).format(dateFormat) : '';
                const submit_type = current_form_value?.submit_type;
                return (
                  <div key={field.key}>
                    <Space key={field.key} align="baseline">
                      <Form.Item
                        noStyle
                        shouldUpdate={(prevValues, curValues) =>
                          prevValues.sights !== curValues.sights
                        }
                      >
                        {() => (
                          <Form.Item
                            {...field}
                            label="期望到港日期:"
                            name={[field.name, 'date']}
                            rules={[
                              {
                                required: true,
                                message: '请选择期望到港日期',
                              },
                            ]}
                          >
                            <DatePicker onChange={(e) => datePickerChange(field, field.key, index, e)} disabledDate={disabledDate} />
                          </Form.Item>
                        )}
                      </Form.Item>
                      <Form.Item
                        {...field}
                        label="数量"
                        min={0}
                        name={[field.name, 'submit_number']}
                        rules={[
                          {
                            required: true,
                            message: '请填写柜数量',
                          },
                        ]}
                      >
                        <Select style={{ width: 200 }} onChange={(e) => submitNumberChange(field, field.key, index, e)}>
                          {baseNumber.map(item => <Option value={item} key={item}>{item}</Option>)}
                        </Select>
                      </Form.Item>
                      <span>柜</span>
                      <MinusCircleOutlined onClick={() => remove(field.name)} />
                      {
                        +submit_number === 0.5 ?
                          <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, curValues) => prevValues.sights !== curValues.sights}
                          >
                            {() => (
                              <Form.Item
                                {...field}
                                label=""
                                name={[field.name, 'submit_type']}
                                rules={[
                                  {
                                    required: true,
                                    message: '请选择拼柜方式',
                                  },
                                ]}
                              >
                                <Radio.Group onChange={(e) => radioChange(field, field.key, index, e)}>
                                  <Radio value={1}>自己发起拼柜</Radio>
                                  <Radio value={2} disabled={!companyList.filter(item => item.expected_date === date).length}>参与拼柜</Radio>
                                </Radio.Group>
                              </Form.Item>
                            )}
                          </Form.Item> : null
                      }
                      {
                        +submit_type === 2 && companyList.filter(item => item.expected_date === date).length ? <Form.Item
                          noStyle
                          shouldUpdate={(prevValues, curValues) => prevValues.sights !== curValues.sights}
                        >
                          {() => (
                            <Form.Item
                              {...field}
                              label="拼柜方:"
                              name={[field.name, 'expected_id']}
                              rules={[
                                {
                                  required: true,
                                  message: '请选择拼柜方',
                                },
                              ]}
                            >
                              <Select style={{ width: 200 }} >
                                {companyList.filter(item => item.expected_date === date).map(item => <Option value={item.id} key={item.id}>{item.company_name}</Option>)}
                              </Select>
                            </Form.Item>
                          )}
                        </Form.Item> : null
                      }

                    </Space>
                  </div>
                );
              })}

              <Form.Item>
                <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>添加期望到港日期</Button>
              </Form.Item>
            </>
          )}
        </Form.List>
        <Form.Item style={{ textAlign: 'right' }}>
          <Button type="primary" htmlType="submit">确定</Button>
        </Form.Item>
      </Form>
      <Table
        rowKey={(record) => record.address_id + '-' + record?.expected_date + '-' + record?.submit_number + '-' + record.index}
        columns={columns}
        dataSource={(list || []).filter(item => String(item.status) !== '0').map((item, index) => ({ ...item, index }))}
        pagination={false}
      />
      <Row style={{ marginTop: '20px', textAlign: 'center' }}>
        <Col span={8} offset={8}>
          <Button type='primary' onClick={() => save()} style={{ marginRight: '20px' }}>{reportType === '1' ? '提报' : '保存'}</Button>
          <Button onClick={() => cancelEdit()}>取消</Button>
        </Col>
      </Row>
    </div>
  );
};



export default QuotationEdit;
